import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Document } from '@models/matter';

export interface DocumentDialogData {
	document: Document;
}

export type DocumentDialogClose = Document;

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-delete-document-dialog',
	templateUrl: 'document-delete-dialog.component.html',
	standalone: false,
})
export class DocumentDeleteDialogComponent {
	document: Document;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DocumentDialogData,
		private dialogRef: MatDialogRef<DocumentDeleteDialogComponent>,
	) {
		this.document = data.document;
	}

	cancelModal(): void {
		this.dialogRef.close(false);
	}

	deleteDocument(): void {
		const data: DocumentDialogClose = this.document;
		this.dialogRef.close(data);
	}
}
